"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author gevorg.avetisyan on 2/10/2017.
 */
var DisaggregationMeta = /** @class */ (function () {
    function DisaggregationMeta(id, name, systemName) {
        this.id = id;
        this.name = name;
        this.systemName = systemName;
    }
    DisaggregationMeta.prototype.getName = function () {
        return this.name.getValue(3);
    };
    DisaggregationMeta.getMultilingualMap = function (json) {
        var map = new Map();
        for (var k in json) {
            map.set(Number(k), json[k]);
        }
        return map;
    };
    return DisaggregationMeta;
}());
exports.DisaggregationMeta = DisaggregationMeta;
//# sourceMappingURL=disaggregation.meta.js.map